interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SchemaOrg({ type, data = {} }: SchemaOrgProps) {
  const baseOrg = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '安心导航',
    url: 'https://anxindaohang.com',
    description: '成人免费网站精选导航 · 正规资源一站汇总',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@anxindaohang.com',
      contactType: 'customer service',
    },
  };

  const baseWebSite = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '安心导航',
    url: 'https://anxindaohang.com',
    description: '成人免费网站精选导航 · 正规资源一站汇总',
    inLanguage: 'zh-CN',
  };

  const baseWebPage = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '安心导航',
    url: 'https://anxindaohang.com',
    inLanguage: 'zh-CN',
  };

  let schema: Record<string, unknown>;

  switch (type) {
    case 'Organization':
      schema = { ...baseOrg, ...data };
      break;
    case 'WebSite':
      schema = { ...baseWebSite, ...data };
      break;
    case 'WebPage':
      schema = { ...baseWebPage, ...data };
      break;
    case 'Article':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'Article',
        inLanguage: 'zh-CN',
        ...data,
      };
      break;
    case 'FAQPage':
      schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        ...data,
      };
      break;
    default:
      schema = {};
  }

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}